@if (order) {
  <span data-zid="order-item-exec-type">
    @if (order | orderExecType: 'tsl') {
      @if (order.trailingPricePct) {
        TSL ({{ order.trailingPricePct | number }}%)
      } @else if (order.trailingPriceAbs) {
        TSL ({{ order.trailingPriceAbs | currency }})
      } @else {
        TSL
      }
    } @else {
      {{ order.execType | displayLabel }}
    }
  </span>
}
